module.exports = __webpack_public_path__ + "img/4img_page-0001.53083c13.jpg";